import React from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@material-ui/core';
// import { useStore } from '@tanstack/react-form'; // KALDIRILDI
import moment from 'moment';
import { FieldLabel, FieldText } from '../../components/Field';

function useFormValues(form, selector) {
  const [sel, setSel] = React.useState(() => selector(form.values));
  React.useEffect(() => {
    const unsub = form.subscribe(() => setSel(selector(form.values)));
    return unsub;
  }, [form, selector]);
  return sel;
}

export function Customer({ form }) {
    const { Phones, ContactName, ContactPhone, Addresses, ConsumerTypeName, ConsumerSecretNotes } =
      useFormValues(form, v => ({
        Phones: v.Phones || [],
        ContactName: v.ContactName,
        ContactPhone: v.ContactPhone,
        Addresses: v.Addresses || [],
        ConsumerTypeName: v.ConsumerTypeName,
        ConsumerSecretNotes: v.ConsumerSecretNotes || []
      }));

    return (
        <Card>
            <CardHeader title="Customer Detail" />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs={12} sm={6} lg={6}>
                        <FieldLabel>Phone</FieldLabel>
                        {Phones.length > 0 ? (
                            Phones.map((phone, index) => (
                                <FieldText key={index}>
                                    {phone.PhoneType}: {phone.Phone}
                                </FieldText>
                            ))
                        ) : (
                            <FieldText>No additional phone numbers available</FieldText>
                        )}
                        <FieldLabel>Address</FieldLabel>
                        {Addresses.length > 0 ? (
                            Addresses.map((address, index) => (
                                <FieldText key={index}>
                                    {address.Address}
                                    <br />
                                    {address.City}
                                </FieldText>
                            ))
                        ) : (
                            <FieldText>No additional addresses available</FieldText>
                        )}
                        <FieldLabel>Contact</FieldLabel>
                        <FieldText>
                            {ContactName} :+ {ContactPhone}
                        </FieldText>
                        <FieldLabel>Customer Type</FieldLabel>
                        <FieldText>{ConsumerTypeName || 'Not specified'}</FieldText>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <Card>
                            <CardHeader title="Customer Internal Notes" />
                            <Divider />
                            {ConsumerSecretNotes.length > 0 ? (
                                <CardContent>
                                    <List>
                                        {ConsumerSecretNotes.map((note, index) => (
                                            <ListItem alignItems="flex-start" key={index}>
                                                <ListItemText
                                                    secondary={
                                                        <Typography
                                                            component="span"
                                                            variant="body1"
                                                            color="textPrimary"
                                                        >
                                                            <b>User:</b> {note.UserSecretNote}
                                                            <br />
                                                            <b>Date:</b> {moment(note.Date).format('DD/MM/YYYY HH:mm')}
                                                            <br />
                                                            <b>Message:</b> {note.SecretNote}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            ) : (
                                <CardContent>
                                    <Typography color="textSecondary">
                                        No internal notes available for this customer.
                                    </Typography>
                                </CardContent>
                            )}
                        </Card>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
